import { apiClient } from '../../common/ApiClient';
import { ClassifierGroupArraySchema, ClassifierGroupArrayType } from '../types';
import { expand } from 'uri-template-lite';
import { ClassifierUrl } from './ClassifierUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { keepStaleInMinutes } from '../../common/queryClient/utils';

async function getClassifierGroups() {
  return apiClient
    .get<ClassifierGroupArrayType>(
      expand(ClassifierUrl.CLASSIFIER_WITH_GROUPS, [])
    )
    .then((response) => ClassifierGroupArraySchema.parse(response.data));
}

export const useClassifierGroupsQuery = createApiQueryHook(
  ['classifier-groups'],
  getClassifierGroups,
  keepStaleInMinutes(5)
);
